import { render, staticRenderFns } from "./NotificationMessage.vue?vue&type=template&id=94bc9ca0&scoped=true&"
import script from "./NotificationMessage.vue?vue&type=script&lang=js&"
export * from "./NotificationMessage.vue?vue&type=script&lang=js&"
import style0 from "./NotificationMessage.vue?vue&type=style&index=0&id=94bc9ca0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94bc9ca0",
  null
  
)

export default component.exports